import type { ReactNode } from "react";

export const moduleName = "modals";

export type Modal = {
	id: string;
	title?: string;
	description?: string;
	children?: ReactNode;
	onCancel?: () => void;
	onConfirm: () => void;
	hideCancel?: boolean;
	// Lets the caller gate Confirm on its own validation (e.g. a text input
	// in `children`); flip it via setModalDisabled as that state changes.
	disabled?: boolean;
};

export type ModalsState = {
	currentModal: Modal | null;
};
